export function findAssetConflicts(projects, currentProjectId, assignedAssetIds) {
  const current = projects.find(project => project.id === currentProjectId);
  if (!current?.date) return new Set();
  const assigned = new Set(assignedAssetIds);
  const conflicts = new Set();
  projects.forEach(project => {
    if (project.id === currentProjectId || project.date !== current.date) return;
    (project.assignedAssetIds || []).forEach(assetId => {
      if (assigned.has(assetId)) conflicts.add(assetId);
    });
  });
  return conflicts;
}
